import { render, staticRenderFns } from "./StudentMediumCourseModules.vue?vue&type=template&id=701fe328&scoped=true&"
import script from "./StudentMediumCourseModules.vue?vue&type=script&lang=js&"
export * from "./StudentMediumCourseModules.vue?vue&type=script&lang=js&"
import style0 from "./StudentMediumCourseModules.vue?vue&type=style&index=0&id=701fe328&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701fe328",
  null
  
)

export default component.exports